// Keep in sync with Household.DIET_CHOICES in backend/recipes/models.py
export const DIET_OPTIONS = [
  { value: 'none', label: 'No Preference' },
  { value: 'keto', label: 'Keto' },
  { value: 'low_carb', label: 'Low-Carb' },
  { value: 'diabetic', label: 'Diabetic-Friendly' },
  { value: 'low_sugar', label: 'Low-Sugar' },
  { value: 'mediterranean', label: 'Mediterranean' },
  { value: 'vegan', label: 'Vegan' },
  { value: 'vegetarian', label: 'Vegetarian' },
  { value: 'paleo', label: 'Paleo' },
];

// Common presets shown as quick-add pills; users can also type a custom
// entry, so this list doesn't need to be exhaustive.
export const ALLERGY_OPTIONS = [
  'Gluten-Free', 'Nut Allergy', 'Peanut Allergy', 'Dairy-Free',
  'Shellfish Allergy', 'Egg Allergy', 'Soy Allergy', 'Fish Allergy',
  'Sesame Allergy', 'Low-Sodium', 'Kosher', 'Halal',
];

// Keep in sync with Household.ALL_MEAL_TYPES in backend/recipes/models.py
export const MEAL_TYPE_OPTIONS = [
  { value: 'breakfast', label: 'Breakfast' },
  { value: 'lunch', label: 'Lunch' },
  { value: 'dinner', label: 'Dinner' },
];

// Upper bound on prep + cook time; null means no limit. Keep the backend's
// 5-minute minimum (HouseholdSerializer.validate_max_total_time) in mind if
// adding shorter options.
export const MAX_TIME_OPTIONS: { value: number | null; label: string }[] = [
  { value: null, label: 'Any Time' },
  { value: 15, label: '15 min' },
  { value: 30, label: '30 min' },
  { value: 45, label: '45 min' },
  { value: 60, label: '1 hour' },
  { value: 90, label: '1½ hours' },
];
